export default function showNavigation({ to, next }) {
    $('body').removeClass('show-navigation')
    if (to.matched.some(record => record.meta.hasNavigation)) {
        $('body').addClass('show-navigation')
    }

    return next()
}